export { default } from './ParticipantItem'



// WEBPACK FOOTER //
// ./src/App/components/ParticipantItem/index.js